export function solea_generate_ajax_url(ajaxmethode, params) {
	console.log(solea_ajax_url);
	return solea_ajax_url + '?action=solea_show_ajax&&method=' + ajaxmethode + '&' + params;
}
export function solea_load_ajax_nw(ajaxmethode, params='') {
	ajaxurl = solea_generate_ajax_url( ajaxmethode, params );
	window.open( ajaxurl );
}


export function __(key, domain) {
	//domain not in use yet
	return solea_i18n[key] || key;
}
export function _nonce() {
	return solea_user + '|' + solea_nonce;
}

export function _solea_get_local_groups() {
	return solea_local_groups;
}

export function _solea_user_is_admin() {
	return solea_user_is_admin === 'true';
}



export function solea_searchtable(tableId, searchField) {
	var input  = searchField;
	var filter = input.value.toUpperCase();
	var table  = document.getElementById( tableId );
	var rows   = Array.from( table.getElementsByTagName( "tr" ) );

	rows.forEach(
		function (row) {
			solea_filter_row( row, filter );
		}
	);
}

function solea_filter_row(row, filter) {
	var cells         = Array.from( row.getElementsByTagName( "td" ) );
	var shouldDisplay = cells.some(
		function (cell) {
			var cellText = cell.textContent || cell.innerText;
			return cellText.toUpperCase().indexOf( filter ) > -1;
		}
	);

	row.style.display = shouldDisplay ? "" : "none";
}


function solea_check_elements(fields) {
	let no_errors = true;

	fields.forEach(
		function (field) {
			let element = document.getElementsByName( field )[0];

			if ( ! element) {
				console.error( `Element with name "${field}" not found.` );
				no_errors = false;
				return; // Skip to the next field
			}

			if (element.value.trim() === '') {
				no_errors = false;
				element.classList.add( 'solea-error' );
			} else {
				element.classList.remove( 'solea-error' );
			}
		}
	);

	return no_errors;
}

function solea_is_valid_iban(iban) {
	iban = iban.replace( /\s+/g, '' ).toUpperCase();

	if (iban.length !== 22) {
		return false;
	}

	if ( ! iban.startsWith( 'DE' )) {
		return false;
	}

	iban = iban.slice( 4 ) + iban.slice( 0, 4 );

	const convertedIban = iban.split( '' ).map(
		char => {
        const code  = char.charCodeAt( 0 );
        return code >= 65 && code <= 90 ? (code - 55).toString() : char;
		}
	).join( '' );

	let remainder = convertedIban;
	while (remainder.length > 2) {
		const block = remainder.slice( 0, 9 );
		remainder   = (parseInt( block, 10 ) % 97).toString() + remainder.slice( 9 );
	}

	return parseInt( remainder, 10 ) % 97 === 1;
}

function solea_is_valid_email(email) {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test( email );
}

export function solea_print_list(listtype, event_id) {
	window.open( solea_ajax_url + '?action=solea_print_list&solea_nonce=' + _nonce() + '&list-type=' + listtype + '&event-id=' + event_id );
}